import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

/**
 * The app's single QueryClient. `onError` fires for every failed query and
 * mutation — the one place to surface an ApiError (toast, redirect on 401, …).
 * Server data stays fresh for 30s and retries once; mutations never retry.
 */
export function createQueryClient(onError?: (error: unknown) => void): QueryClient {
	return new QueryClient({
		queryCache: new QueryCache({ onError }),
		mutationCache: new MutationCache({ onError }),
		defaultOptions: {
			queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
			mutations: { retry: 0 },
		},
	});
}
